import { render, staticRenderFns } from "./Fund-CorrelationIndex.vue?vue&type=template&id=ed1b3c6c&scoped=true&"
import script from "./Fund-CorrelationIndex.vue?vue&type=script&lang=js&"
export * from "./Fund-CorrelationIndex.vue?vue&type=script&lang=js&"
import style0 from "./Fund-CorrelationIndex.vue?vue&type=style&index=0&id=ed1b3c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1b3c6c",
  null
  
)

export default component.exports